// extracted by mini-css-extract-plugin
export default {"recos":"z4-z","productCardOverride":"A4-z","rowHasBadge":"B4-z"};